import { useEffect, type RefObject } from 'react';

const useClickAway = (ref: RefObject<any>, callback: (e: MouseEvent) => void) => {
    useEffect(() => {
        const listener = (e: MouseEvent) => {
            if (ref?.current?.contains(e.target as Node)) {
                return;
            }

            callback(e);
        };

        document.addEventListener('mousedown', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [ref, callback]);
};

export default useClickAway;
